import { render, staticRenderFns } from "./Updatelimit.vue?vue&type=template&id=4d79edde&"
import script from "./Updatelimit.vue?vue&type=script&lang=js&"
export * from "./Updatelimit.vue?vue&type=script&lang=js&"
import style0 from "./Updatelimit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports